import React, { MouseEventHandler } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Theme } from '@mui/material';
interface KeyButtonProps {
  letter: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const KeyButton: React.FC<KeyButtonProps> = ({ letter, onClick, style, disabled }) => {
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Box
      component={Button}
      minWidth={isSmallScreen ? 31 : 36} // adjust as needed
      height={isSmallScreen ? 31 : 36} // adjust as needed
      m={0}
      borderRadius="4px"
      border="2px solid transparent"
      bgcolor={disabled ? "#aaaaaa" : "#dce1ed"} // changed color if disabled
      p={0}
      onClick={onClick}
      color={disabled ? "#888888" : "#414a5e"} // changed color if disabled
      fontWeight= {"700"}
      padding={"3px"}
      margin={"3px"}
      disabled={disabled}
      style={style}
    >
      {letter}
    </Box>
  );
};

export default KeyButton;
